module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/consultancy/consultancy.component.html
// module id = ./src/app/Pages/tasks/consultancy/consultancy.component.html
// module chunks = main